import { createTheme } from '@mui/material';
import { yellow } from '@mui/material/colors';

const custom99GiftTheme = createTheme({
  palette: {
    primary: {
      main: '#002865',
    },
    primaryDark: {
      main: '#002255',
    },
    secondary: {
      main: '#00B8EE',
      light: '#edf8fe',
      light1: '#daf2fd',
      light2: '#c8ebfb',
      light3: '#b5e4fa',
    },
    white: {
      main: '#ffffff',
      light: '#e3e3e3',
    },
    dark: {
      main: '#000000',
      main2: '#212529',
    },
    footer: {
      main: '#184282',
    },
    textPrimary: {
      main: '#454545',
      main1: '#505050',
    },
    backgroundPrimary: {
      main: '#F1F5F6',
    },
    boxShadowPrimary: {
      main: '#808080',
    },
    borderPrimary: {
      main: '#dee2e6',
    },
    lightSecondary: {
      main: '#deebff',
    },
    green: {
      main: '#008000',
    },
    gradientTheme: 'linear-gradient(180deg, #0B4AA2 0%, #0A3C84 100%)',
    apparel: {
      main: '#FFB533',
    },
    mbackground: {
      main: '#E2EEFF',
      bg2: '#e4f4f8',
    },
    background: {
      main1: '#00286514',
      main2: '#deebff',
      main3: '#f7f7f7',
    },
    borderColor: {
      main: '#deebff',
      main1: '#dee2e6',
      main2: '#00286514',
      yellow4: yellow[400],
    },
  },
  typography: {
    fontFamily: 'Celias, sans-serif',
    main: 'Celias',
  },
  shape: {
    borderRadius: 3,
    sectionRadius: 16,
    cardRadius: 8,
    buttonRadius: 2,
    borderCurves: {
      subtle: '98% 2% 100% 2% / 3% 96% 4% 97%',
      wave: '37% 63% 70% 30% / 30% 30% 70% 70%',
      bubble: '71% 29% 70% 30% / 30% 56% 44% 70%',
      organic: '66% 34% 46% 54% / 57% 36% 64% 43%',
    },
  },
  sectionDesigns: {
    default: {
      border: 1,
      borderColor: 'borderColor.main1',
      borderRadius: 'shape.sectionRadius',
      boxShadow: 0,
      px: 2,
      py: 3,
    },
    giftCardSection: {
      border: 9,
      borderColor: 'borderColor.main2',
      borderRadius: 5,
      boxShadow: 1,
      bgcolor: 'white.main',
      py: 2,
    },
    highlighted: {
      border: 2,
      borderColor: 'primary.main',
      borderRadius: 'sectionRadius',
      boxShadow: '0px 4px 20px rgba(0, 40, 101, 0.15)',
      bgcolor: 'white.main',
    },
    flat: {
      border: 0,
      borderRadius: 0,
      bgcolor: 'backgroundPrimary.main',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: theme.shape.buttonRadius,
          textTransform: 'none',
          fontWeight: 600,
        }),
      },
    },
    MuiCard: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: theme.shape.cardRadius,
          transition: 'all 0.3s ease',
          '&:hover': {
            boxShadow: theme.shadows[6],
          },
        }),
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: theme.shape.sectionRadius,
        }),
      },
    },
  },

  animations: {
    slideTop: {
      animation: 'slideTop 0.4s ease-in-out',
    },
    slideBottom: {
      animation: 'slideBottom 0.4s ease-in-out',
    },
    slideLeft: {
      animation: 'slideLeft 0.4s ease-in-out',
    },
    slideRight: {
      animation: 'slideRight 0.4s ease-in-out',
    },
    fadeIn: {
      animation: 'fadeIn 0.5s ease-in-out',
    },
    zoomIn: {
      animation: 'zoomIn 0.4s ease-in-out',
    },
  },
});

export default custom99GiftTheme;
